import { Component } from '@angular/core';

@Component({
  selector: 'app-app-disabled',
  templateUrl: './app-disabled.component.html',
  styleUrls: ['./app-disabled.component.css']
})
export class AppDisabledComponent {}
